import $ from 'jquery'
import Backbone from 'backbone'
import template from './dataset-button-controls.hbs'
import * as datasetSelectorOptions from './dataset-selector-options'
import ObjectSelectorButton from '../components/object-selector-button'
import _ from 'lodash'
import DataSourceLink from '../components/data-source-selector/data-source-link'

const DatasetButtonControls = Backbone.View.extend(/** @lends {DatasetButtonControls} */{

	className: 'dataset-button-controls',

	// this.dataset is the selected dataset as a plain JavaScript object

	/**
	 * Renders the controls related to displaying a button which allows for the
	 * selection of a dataset. The other controls are an optional Clear button,
	 * and a link to the dataset.
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Dataset} [options.dataset] the dataset to be initially selected
	 * in the selector
	 *
	 * @param {Object} [options.showClearButton=false]
	 */
	initialize: function(options = {}) {
		this.options = options
		this.showClearButton = options.showClearButton ?? false
		this.dataset = options.dataset
	},

	render: function() {
		this.$el.html(template())

		this.renderDatasetSelectorButton()
		this.renderDataSourceLink()
		this.toggleClearButton()

		return this
	},

	renderDatasetSelectorButton: function() {
		let selectorOptions = datasetSelectorOptions.forButton({
			dataset: this.dataset
		})
		selectorOptions.onSelect = dataset => {
			return $.when(this.fetchDataset(dataset.id)).then(dataset => {
				this.dataset = dataset
			})
		}

		this.objectSelectorButton = new ObjectSelectorButton(selectorOptions)
		this.$('.dataset-selector-button-container').append(this.objectSelectorButton.el)
		this.objectSelectorButton.render()

		this.objectSelectorButton.on('change', () => {
			this.trigger('change', this.dataset)
		})
	},

	fetchDataset: function(datasetId) {
		let url =
			`api/datasets/${datasetId}?fields=true&linkedDatasets=true`
		return $.get(url)
	},

	renderDataSourceLink: function() {
		this.dataSourceLink?.remove()
		let datasetId = _.get(this.objectSelectorButton.val(), 'id')
		if (!datasetId) {
			return
		}
		this.dataSourceLink = new DataSourceLink({
			section: 'datasets',
			id: datasetId
		})
		this.$('.source-data-link-container').append(this.dataSourceLink.el)
		this.dataSourceLink.render()
	},

	toggleClearButton: function() {
		this.$('.clear.button')
			.toggleClass('is-not-displayed', !this.showClearButton)
	},

	autoRemove: true

})

export default DatasetButtonControls

DatasetButtonControls.__filename__ = 'datasets/dataset-button-controls.js'
